import { stringify } from "qs";
import { decamelizeKeys } from "humps";
import { NextRouter } from "next/router";
import { removeEmpty } from "./objectUtil";
import {
  modalParamKeys,
  toObjFromLocationSearch,
  toObjFromUrl,
} from "./paramUtil";

export function replaceUrl(param: any, router: NextRouter): void {
  // console.log(router);
  const path = getBasePath(router.asPath);
  const queryParam = decamelizeKeys(removeEmpty(param));
  let newUrl = `${path}?${stringify(queryParam, {
    arrayFormat: "indices",
  })}`;
  if (location.hash) {
    newUrl += location.hash; // lineなどがaccessTokenなどをくっつけてるため
  }
  // shallow: trueにしないと再度サーバーサイドの処理が動作してしまうため注意
  router.replace(newUrl, null, { shallow: true });
}

export function replaceSameUrl(router: NextRouter): void {
  router.replace(router.asPath, null, { shallow: true });
}

export function pushSameUrl(router: NextRouter): void {
  const path = getBasePath(router.asPath);
  const queryParam = toObjFromUrl(router.asPath);
  // 全く同じURLだとpushできないためqueryを追加する
  queryParam.rp = 1;
  let newUrl = `${path}?${stringify(queryParam, {
    arrayFormat: "indices",
  })}`;
  if (location.hash) {
    newUrl += location.hash; // lineなどがaccessTokenなどをくっつけてるため
  }
  router.push(newUrl, null, { shallow: true });
}

export function getUrlModalParams(): any {
  const params = {};
  const queryObject = toObjFromLocationSearch();
  modalParamKeys.map((key) => {
    const routerParam = queryObject[key];
    if (routerParam) {
      params[key] = routerParam;
    }
  });
  return params;
}

export function updateHotelSearchUrl(
  param: any,
  isParamUpdated: boolean,
  router: NextRouter,
): void {
  const path = getBasePath(router.asPath);
  const queryParam = decamelizeKeys(removeEmpty(param));
  let newUrl = `${path}?${stringify(queryParam, {
    arrayFormat: "indices",
  })}`;
  if (location.hash) {
    newUrl += location.hash; // lineなどがaccessTokenなどをくっつけてるため
  }
  // shallow: trueにしないと再度サーバーサイドの処理が動作してしまうため注意
  if (isParamUpdated) {
    router.replace(newUrl, null, { shallow: true });
  } else {
    router.push(newUrl, null, { shallow: true });
  }
}

export function getBasePath(url: string) {
  const pathWithoutHash = url.split("#")[0];
  return pathWithoutHash.split("?")[0];
}

export function cdnLoader({ src }) {
  return src;
}

// 常に1つしか登録しない
let processStopBrowserBackPopState: any;
export const stopBrowserBackOnce = (
  router: NextRouter,
  callback: any,
  url?,
) => {
  if (url) {
    router.push(url, null, { shallow: true });
  }
  processStopBrowserBackPopState = () => {
    callback();
    window.removeEventListener("popstate", processStopBrowserBackPopState);
  };
  window.removeEventListener("popstate", processStopBrowserBackPopState);
  window.addEventListener("popstate", processStopBrowserBackPopState);
};
export const startBrowserBack = () => {
  window.removeEventListener("popstate", processStopBrowserBackPopState);
};
